import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from '../../../components/Page';
import Logo from '../../../components/Logo';
import useAuth from '../../../hooks/useAuth';
import LoginAuthView from './LoginAuthView';
import { alterarCorImagemFundo } from 'src/utils/functions';
import { IMG_FUNDO } from 'src/constants';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    background: `url(${IMG_FUNDO}) bottom/cover no-repeat`,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
  },
  banner: {
    backgroundColor: theme.palette.background.paper,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  bannerChip: {
    marginRight: theme.spacing(2)
  },
  methodIcon: {
    height: 30,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  cardContainer: {
    paddingBottom: 80,
    paddingTop: '7vw'
  },
  cardContent: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    minHeight: 200
  },
  currentMethodIcon: {
    height: 40,
    '& > img': {
      width: 'auto',
      maxHeight: '100%'
    }
  },
  cardMain: {
    borderRadius: theme.spacing(2)
  }
}));

const LoginView = () => {
  const classes = useStyles();
  const { method } = useAuth();
  const { loading } = useSelector(
    (state) => ({
      loading: state.account.loading
    }),
    shallowEqual
  );

  useEffect(() => {
    alterarCorImagemFundo(classes, IMG_FUNDO);
  }, [classes.root]);

  return (
    <Page className={classes.root} title="Login">
      <Box mt={4} ml={8} display="flex" justifyContent="left">
        <RouterLink to="/">
          <Logo width="180px" />
        </RouterLink>
      </Box>
      <Container className={classes.cardContainer} maxWidth="sm">
        <Card className={classes.cardMain}>
          <CardContent className={classes.cardContent}>
            <Box flexGrow={1}>
              {method === 'FirebaseAuth' && (
                <LoginAuthView
                  loading={loading}
                />
              )}
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default LoginView;
